import styled from "styled-components/macro";

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;
  margin: 20px auto 44px;

  @media (max-width: 979px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding-bottom: 20px;
    margin-bottom: 24px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Tag = styled.button<{isActive?: boolean}>`
  font-size: 18px;
  line-height: 18px;
  padding: 11px 20px;
  border-radius: 20px;
  color: inherit;
  white-space: nowrap;
  font-weight: 500;
  transition: 0.2s;
  background-color: ${({ isActive }) => isActive ? "#BFDCF5" : "#fff"};
  border: 1px solid ${({ isActive }) => isActive ? "#BFDCF5" : "#141414"};

  @media (max-width: 979px) {
    font-size: 16px;
  }
`

export const ErrorMessage = styled.span`
  font-size: 55px;
  text-align: center;
  display: block;
`;

export const PostsList = styled.ul`
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 50px;
  column-gap: 24px;
    
  @media (max-width: 1439px) {
    row-gap: 38px;
    column-gap: 12px;
  }

  @media (max-width: 1439px) {
    row-gap: 26px;
  }
`;

